<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2">
            <div class="d-flex align-items-center border bg-white rounded p-1 me-2">
              <router-link to="/crm/deals-list" class="btn btn-icon btn-sm me-1">
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link to="/crm/deals-grid" class="btn btn-icon btn-sm active bg-primary text-white">
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <button class="btn btn-white d-inline-flex align-items-center" @click="exportCsv">
              <i class="ti ti-file-type-csv me-1"></i>Export CSV
            </button>
          </div>

          <div class="mb-2">
            <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#add_deals" class="btn btn-primary d-flex align-items-center" v-can="'Deal.Create'">
              <i class="ti ti-circle-plus me-2"></i>Add Deal
            </a>
          </div>

          <div class="head-icons ms-2">
            <a href="javascript:void(0);" id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between">
            <h5>Deals Grid</h5>
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="sortLabel = 'Recently Added'">Recently Added</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="sortLabel = 'Name A to Z'">Name A to Z</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="sortLabel = 'Name Z to A'">Name Z to A</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="sortLabel = 'Last 30 Days'">Last 30 Days</a></li>
                <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="sortLabel = 'Last 7 Days'">Last 7 Days</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <DealsBoard />
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a></p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import DealsBoard from "./deals-board.vue";
import { useDealStore } from "@/stores/dealStore";
import { usePipelineStore } from "@/stores/pipelineStore";
import { useUserStore } from "@/stores/userStore";

const title = "Deals";
const text = "CRM";
const text1 = "Deals Grid";

const dealStore = useDealStore();
const pipeStore = usePipelineStore();
const userStore = useUserStore();
const sortLabel = ref("Recently Added");

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

const exportRows = computed(() => {
  const rows = Array.isArray(dealStore.items) ? [...dealStore.items] : [];

  if (sortLabel.value === "Name A to Z") {
    rows.sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
  } else if (sortLabel.value === "Name Z to A") {
    rows.sort((a, b) => String(b.name || "").localeCompare(String(a.name || "")));
  } else {
    rows.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  }

  const cutoffDays = sortLabel.value === "Last 30 Days" ? 30 : sortLabel.value === "Last 7 Days" ? 7 : null;
  if (!cutoffDays) return rows;

  const cutoff = Date.now() - cutoffDays * 24 * 60 * 60 * 1000;
  return rows.filter((deal) => new Date(deal.created_at || 0).getTime() >= cutoff);
});

function exportCsv() {
  const header = ["Name", "Account", "Stage", "Owner", "Amount", "Expected Close", "Created At"];
  const body = exportRows.value.map((deal) => [
    deal.name || "",
    deal.company_name || deal.client?.name || "",
    deal.stage?.name || "",
    [deal.owner?.first_name, deal.owner?.last_name].filter(Boolean).join(" ") || deal.owner?.email || "",
    `${deal.currency || "KES"} ${Number(deal.amount || 0).toFixed(2)}`,
    deal.expected_close_date || "",
    deal.created_at || "",
  ]);
  const csv = [header, ...body]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `crm-deals-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

onMounted(async () => {
  if (!pipeStore.items?.length) await pipeStore.ensureAll({ per_page: 200 });
  if (!userStore.users?.length) await userStore.fetchUsers({ per_page: 200 });
  await dealStore.fetchAll();
});
</script>


